import React from 'react';
import { Card, CardContent } from '../ui/Card';
import { Thermometer, Wind, Briefcase, Radio } from 'lucide-react';
export function BenefitsSection() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="mx-auto max-w-3xl text-center mb-16" data-id="element-3">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl font-serif" data-id="element-4">
            Qué vas a encontrar adentro
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-5">
            Tu botiquín emocional digital: 21 técnicas de alivio inmediato.
          </p>
        </div>

        <div className="mx-auto max-w-4xl grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-6">
          <Card className="border-l-4 border-l-blue-500 hover:shadow-md transition-shadow" data-id="element-7">
            <CardContent className="flex items-start p-6" data-id="element-8">
              <div className="mr-4 mt-1" data-id="element-9">
                <Thermometer className="h-6 w-6 text-blue-500" data-id="element-10" />
              </div>
              <div data-id="element-11">
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-12">
                  El Protocolo de Shock Térmico
                </h3>
                <p className="text-slate-600" data-id="element-13">
                  Cómo usar la temperatura para resetear tu nervio vago
                  instantáneamente.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-l-4 border-l-purple-500 hover:shadow-md transition-shadow" data-id="element-14">
            <CardContent className="flex items-start p-6" data-id="element-15">
              <div className="mr-4 mt-1" data-id="element-16">
                <Wind className="h-6 w-6 text-purple-500" data-id="element-17" />
              </div>
              <div data-id="element-18">
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-19">
                  21 Técnicas Tácticas
                </h3>
                <p className="text-slate-600" data-id="element-20">
                  Desde la respiración antipánico hasta el anclaje sensorial
                  para momentos críticos.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-l-4 border-l-orange-500 hover:shadow-md transition-shadow" data-id="element-21">
            <CardContent className="flex items-start p-6" data-id="element-22">
              <div className="mr-4 mt-1" data-id="element-23">
                <Briefcase className="h-6 w-6 text-orange-500" data-id="element-24" />
              </div>
              <div data-id="element-25">
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-26">
                  Guía para la Oficina
                </h3>
                <p className="text-slate-600" data-id="element-27">
                  Cómo calmarte en una reunión o en el trabajo sin que nadie se
                  entere.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-l-4 border-l-green-500 hover:shadow-md transition-shadow" data-id="element-28">
            <CardContent className="flex items-start p-6" data-id="element-29">
              <div className="mr-4 mt-1" data-id="element-30">
                <Radio className="h-6 w-6 text-green-500" data-id="element-31" />
              </div>
              <div data-id="element-32">
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-33">
                  El Escudo Anti-Noticias
                </h3>
                <p className="text-slate-600" data-id="element-34">
                  Cómo proteger tu mente del ruido económico y la incertidumbre
                  actual.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}